import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { BookOpen, FileText, History, ShieldCheck, Users } from 'lucide-react';
import { useAgent } from '../App';

const ITEMS = [
  { id: 'dashboard', label: 'Accueil', path: '/dashboard', icon: ShieldCheck },
  { id: 'report', label: 'Rapport', path: '/nouveau-rapport', icon: FileText },
  { id: 'history', label: 'Historique', path: '/historique', icon: History },
  { id: 'consignes', label: 'Consignes', path: '/consignes', icon: BookOpen },
  { id: 'admin', label: 'Admin', path: '/admin', icon: Users },
];

const isCurrent = (pathname, item) => {
  if (item.id === 'history') {
    return pathname.startsWith('/historique') || pathname.startsWith('/report/edit') || pathname.startsWith('/rapport');
  }
  if (item.id === 'report') return pathname.startsWith('/nouveau-rapport');
  if (item.id === 'admin') return pathname.startsWith('/admin');
  return pathname.startsWith(item.path);
};

const MobileNav = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { currentAgent } = useAgent();
  const items = ITEMS.filter((item) => item.id !== 'admin' || currentAgent?.isAdmin);

  return (
    <nav
      data-testid="mobile-nav"
      className="md:hidden fixed bottom-0 inset-x-0 z-50 border-t border-border bg-card/95 backdrop-blur-md pb-[env(safe-area-inset-bottom)] pl-[var(--sal)] pr-[var(--sar)]"
    >
      {/* Le bouton d'accessibilité occupe le coin droit : on lui laisse la place, sans colonne vide. */}
      <div className={`grid pr-[4.25rem] ${{ 3: 'grid-cols-3', 4: 'grid-cols-4', 5: 'grid-cols-5' }[items.length] || 'grid-cols-4'}`}>
        {items.map((item) => {
          const Icon = item.icon;
          const active = isCurrent(pathname, item);
          return (
            <button
              key={item.id}
              type="button"
              onClick={() => navigate(item.path)}
              data-testid={`mobile-nav-${item.id}`}
              aria-current={active ? 'page' : undefined}
              className={`flex min-h-16 min-w-0 flex-col items-center justify-center gap-1 px-0.5 ${items.length > 4 ? 'text-[11px]' : 'text-xs'} font-semibold focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring ${active ? 'text-primary' : 'text-muted-foreground'}`}
            >
              <Icon className="h-5 w-5" />
              <span className="max-w-full truncate">{item.label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
};

export default MobileNav;
